import {
  ArrowForwardRounded,
  CloseRounded,
  ContentCopyRounded,
  OpenInNewRounded,
} from "@mui/icons-material";
import { Box, Collapse, IconButton } from "@mui/material";

import theme from "../../../../config/Theme";
import { GreyPallet } from "../../../../config/styles";

import MainSolidButton from "../../../MainSolidButton";

import { BannerItemType } from "../../../../types/common";

type MainBannerItemProps = {
  item: BannerItemType;
  collapseIn: boolean;
  onDimiss: () => void;
  onActionClick: () => void;
};

export default function MainBannerItem({
  item,
  collapseIn,
  onDimiss,
  onActionClick,
}: MainBannerItemProps) {
  const typeColor = item.type as "success" | "error" | "warning" | "info";
  const isColored = ["success", "error", "warning", "info"].includes(typeColor);

  return (
    <Collapse key={item.id} in={collapseIn}>
      <Box
        key={item.id}
        style={{
          backgroundColor: isColored ? theme.palette[typeColor].light + "20" : GreyPallet.Light,
          color: isColored ? theme.palette[typeColor].dark : undefined,
          borderRadius: 15,
        }}
        sx={{
          p: 2,
          mb: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>{item.text}</Box>

          {item.dimissable && (
            <IconButton color="inherit" size="small" sx={{ ml: 1 }} onClick={() => onDimiss()}>
              <CloseRounded fontSize="inherit" />
            </IconButton>
          )}
        </Box>

        {item?.action && (
          <Box mt={2} width={"100%"}>
            <MainSolidButton
              small
              color={item.type}
              icon={
                item?.action?.type === "external-link" ? (
                  <OpenInNewRounded />
                ) : item?.action?.type === "clipboard" ? (
                  <ContentCopyRounded />
                ) : (
                  <ArrowForwardRounded />
                )
              }
              onClick={() => onActionClick()}
              text={item?.action?.text}
            />
          </Box>
        )}
      </Box>
    </Collapse>
  );
}
